<template>
  <div>
    <list-table
      ref="tts"
      :url="url"
      title="لیست تسویه های شناسه دار"
      :fields="fields"
      :params="params"
      :excelroute="'excelroute'"
    >
      <template slot="btn">
        <b-button block variant="danger" @click="$bvModal.show('newShare')"
          >تولید شناسه واریز</b-button
        >
      </template></list-table
    >
    <b-modal id="newShare" title="ایجاد شناسه واریز" no-stacking hide-footer>
      <b-row>
        <b-col cols="12" md="6" sm="12">
          <b-form-group label="مبلغ (ریال):">
            <NumberSeprator
              placeholder="مبلغ را به ریال وارد کنید"
              v-model="PayIdItems.amount"
            >
            </NumberSeprator>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6" sm="12">
          <b-form-group label="کد ملی:">
            <b-form-input v-model="PayIdItems.national_code"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12" sm="12">
          <b-form-group label="شماره شبا:">
            <!-- <b-form-input  v-model="PayIdItems.national_code"></b-form-input> -->
            <b-input-group size="lg" append="IR">
              <b-input
                @paste.prevent="pasteIBAN"
                style="word-spacing: 8px"
                maxlength="30"
                class="text-right ltr"
                id="input_card_iban"
                v-model="PayIdItems.account_number"
                placeholder="-- ---- ---- ---- ---- ---- --"
                v-mask="'## #### #### #### #### #### #### ##'"
                required
              ></b-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12" sm="12">
          <b-form-group label="کد درگاه:">
            <b-form-select
              :options="gatewayList"
              v-model="PayIdItems.api"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6" sm="12">
          <b-button block variant="warning" @click="$bvModal.hide('newShare')"
            >انصراف</b-button
          >
        </b-col>
        <b-col cols="12" md="6" sm="12">
          <b-button
            variant="success"
            :disabled="isBusy"
            block
            :class="isBusy ? 'spinner spinner-light spinner-right' : ''"
            @click="CreatePayId"
            >ذخیره</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
    <script>
/**
 * @module TableShowData
 * Custom Vue.js component to display data in a table format
 */
import TableShowData from "../../components/table";
import NumberSeprator from "../../components/numberSeprator";

/**
 * @module persianDate
 * Helper function to format date in persian format
 */
import persianDate from "../../helpers/persianDate";
import httpHelper from "../../helpers/httpHelper";

/**
 * @module SET_BREADCRUMB
 * Action to set breadcrumb for the page
 */
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "depositList",
  data() {
    return {
      /**
       * The API endpoint for fetching the data for the table
       */
      url: "payid/list",
      /**
       * An array of objects that define the columns to be displayed in the table
       * @property {string} key - the key to be used for each column
       * @property {string} label - the label to be displayed in the table header
       * @property {string} [tdClass] - the class to be applied to the data in the column
       * @property {function} [formatter] - a function to format the data in the column
       */
      fields: [
        {
          key: "payid",
          label: "شناسه واریز",
        },
        {
          key: "status",
          label: "وضعیت",
          formatter(value, key, item) {
            switch (value) {
              case 1:
                return "تایید شده";
              case 2:
                return "عودت شده";
              case 4:
                return "واریز با مبلغ اشتباهی";
              default:
                return "در دست بررسی";
            }
          },
          tdClass: (value, key, item) => {
            switch (value) {
              case 1:
                return "text-success";
              case 2:
                return "text-warning";
              case 4:
                return "text-danger";
              default:
                return "";
            }
          },
        },
        {
          key: "national_code",
          label: "کد ملی",
        },
        {
          key: "amount",
          label: "مبلغ (ریال)",
          tdClass: "ltr",
          /**
           * function that format the data in the column
           * @param {string} value - the value of the column
           * @param {string} key - the key of the column
           * @param {Object} item - the item of the column
           */
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "account_number",
          label: "شماره حساب",
        },
        {
          key: "sheba_number",
          label: "شماره شبا واریز کننده",
        },
        {
          key: "tracking_number",
          label: "کد رهگیری",
        },
        {
          key: "created_at",
          label: "تاریخ و ساعت",
          /**
           * function that format the data in the column
           * @param {string} value - the value of the column
           * @param {string} key - the key of the column
           * @param {Object} item - the item of the column
           */
          formatter(value, key, item) {
            return (
              persianDate.getDateByFormat(value) +
              " , " +
              persianDate.getTime(value)
            );
          },
        },
      ],
      /**
       * @typedef {Object} Param
       * @property {string} label - The label to be displayed for the parameter
       * @property {string} field - The field name to be used for the parameter
       * @property {string} type - The type of the input field (e.g. "date-picker", "text")
       */
      /**
       * An array of objects that define the parameters to be used for the API call
       * @type {Param[]}
       */
      params: [
        {
          label: "از تاریخ:",
          field: "dateFrom",
          type: "date-picker",
        },
        {
          label: "تا تاریخ:",
          field: "dateTo",
          type: "date-picker",
        },
        {
          label: "وضعیت:",
          field: "status",
          type: "select",
          options: [
            { value: null, text: "همه ی موارد" },
            { value: "1", text: "تایید شده" },
            { value: "2", text: "برگشت شده" },
            { value: "4", text: "مبلغ واریزی اشتباه" },
          ],
        },
        {
          label: "تاریخ تایید از:",
          field: "c_dateFrom",
          type: "date-picker",
        },
        {
          label: "تاریخ تایید تا:",
          field: "c_dateTo",
          type: "date-picker",
        },
        {
          label: "کد ملی:",
          field: "national_code",
          type: "text",
        },
        {
          label: "کد رهگیری:",
          field: "tracking_number",
          type: "text",
        },
      ],
      gatewayList: [],
      PayIdItems: {
        amount: null,
        post_webhook: null,
        national_code: null,
        api: null,
        account_number: null,
      },
      isBusy: false,
      count: 0,
    };
  },
  components: {
    /**
     * @type {TableShowData}
     */
    "list-table": TableShowData,
    NumberSeprator,
  },
  /**
   * Vue.js lifecycle hook, it will be called when the component is mounted
   * @function
   */
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "لیست تسویه های شناسه دار" },
    ]);
    this.GatewayList();
  },
  methods: {
    GatewayList() {
      httpHelper.getData(`paymentgateways?money_type=483`).then((response) => {
        response.result.forEach((element) => {
          this.gatewayList.push({
            value: element.pin,
            text: `${element.website_name} ${element.id}`,
          });
        });
      });
    },
    CreatePayId() {
      this.isBusy = true;
      this.PayIdItems.account_number = `IR${this.PayIdItems.account_number
        .split(" ")
        .join("")}`;
      httpHelper
        .postData(`payid/generate`, this.PayIdItems)
        .then((response) => {
          if (response.success) {
            this.$bvModal.hide("newShare");
            this.isBusy = false;
            (this.PayIdItems = {
              amount: null,
              post_webhook: null,
              national_code: null,
              api: null,
              account_number: null,
            }),
              this.$refs.tts.LoadData(1, false);
            this.$makeToast(
              "success",
              "شناسه واریز",
              "ششناسه واریز با موفقیت ایجاد شد.",
              5000
            );
          } else {
            this.$makeToast(
              "danger",
              "هشدار",
              "خطایی رخ داده است٬لطفا مجددا تلاش نمایید.",
              5000
            );
          }
        })
        .catch((error) => {
          this.$makeToast(
            "danger",
            "هشدار",
            "خطای سمت سرور رخ داده است.",
            5000
          );
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    pasteIBAN(event) {
      this.PayIdItems.account_number = (
        "IR" + event.clipboardData.getData("text").split(" ").join("")
      )
        .match(/.{1,4}/g)
        .join(" ")
        .replace("IR", "");
    },
  },
};
</script>
    <style>
.ltr {
  direction: ltr;
}
</style>